import { bossDisplayName } from '../../../shared/domain/bossPresentation.js';
import { formatRaidHpEok } from '../../../shared/domain/raidHpFormat.js';
import { raidSeasonStatusLabel } from '../domain/raidSeasonPresentation.js';
import { useRaidSeason } from '../hooks/useRaidSeason.js';
import { LoadingState } from '../../../shared/ui/LoadingState.jsx';

export function RaidSeasonViewer({ mobile = false }) {
  const raid = useRaidSeason();
  const prefix = mobile ? 'mobile-raid-season' : 'desktop-raid-season';
  return (
    <section className={prefix} aria-label="공용 레이드 시즌 정보">
      <div className={`${prefix}-heading`}>
        <div><h2>시즌 보스 설정</h2><p>수정: 플랫폼 관리 → 보스 관리 → 시즌 보스 배치</p></div>
        <strong aria-label={raid.activeSeasonNo ? `${raid.activeSeasonNo}차 진행 중` : '진행 중인 시즌 없음'}>{raid.activeSeasonNo || '-'}</strong>
      </div>
      <div className={`${prefix}-toolbar`}>
        <label><span>조회 차수</span><select aria-label="조회 차수" value={raid.selectedSeason?.season_no || ''} disabled={raid.loading || !raid.seasons.length} onChange={(event) => raid.selectSeason(Number(event.target.value))}>
          {!raid.seasons.length ? <option value="">등록된 차수 없음</option> : null}
          {raid.seasons.map((season) => <option key={season.season_no} value={season.season_no}>{season.season_no}차 · {raidSeasonStatusLabel(season.status)}</option>)}
        </select></label>
      </div>
      {raid.loading ? <LoadingState label="시즌 정보 동기화 중" variant="boss" /> : raid.selectedSeason ? (
        <div className={`${prefix}-boss-list`}>
          {raid.selectedSeason.bosses.map((boss) => <article key={boss.boss_no} className={`${prefix}-boss-card`}>
            <div className={`${prefix}-boss-head`}><span>{boss.boss_no}</span><strong>{bossDisplayName(boss)}</strong><em>약점 속성 · {boss.element}</em></div>
            <div className={`${prefix}-boss-content`}>
            <div className={`${prefix}-boss-preview`}>{boss.image_url ? <img src={boss.image_url} alt={bossDisplayName(boss)} loading="lazy" /> : <span>이미지 없음</span>}</div>
            <div className={`${prefix}-hp-grid`}>
              {[1, 2, 3].map((phase) => <label key={phase}><span>{phase}단 체력</span><strong>{formatRaidHpEok(boss[`phase${phase}_hp`])}</strong></label>)}
              {boss.phase4_infinite ? <div className={`${prefix}-infinite`}><span>4단</span><strong>무한 체력</strong></div> : null}
            </div>
            </div>
            {boss.boss_comment ? <p>{boss.boss_comment}</p> : null}
          </article>)}
        </div>
      ) : <p>플랫폼 관리자가 시즌을 공개하면 표시됩니다. 과거 기록은 차수를 선택해 조회할 수 있습니다.</p>}
      {raid.notice.message ? <p role="alert">{raid.notice.message}</p> : null}
    </section>
  );
}
